import { transport } from 'config/transport';

export function callApiExportThuChiDauNamNhiemKy(congDoanId, academicYear) {
    return transport.get(`/mamnon/cong-doan/${congDoanId}/thuchidaunam-nhiemky/report`, { params: { academicYear }, responseType: 'blob' });
}
